import request from "@/utils/request";

import { IPrinterGetResponse } from "@/interfaces/printer/printer";

/**
 * Get printers of the group
 * Postman: `GET_group_printer`
 */
export async function getPrinters(
  groupId: number
): Promise<IPrinterGetResponse[]> {
  const response = await request({
    url: `/group/${groupId}/printer`,
    method: "get",
  });

  return response.data;
}
